import { MessageTemplateClient } from "@amazon-connect/message-template";
import type { AmazonConnectProvider } from "@amazon-connect/core";
import type { ClientModule } from "../types";

/** MessageTemplateClient: template search and content retrieval. Request-only. */
export const messageTemplateModule: ClientModule = {
  id: "message-template",
  label: "Message Templates",
  pkg: "@amazon-connect/message-template",
  clientExport: "MessageTemplateClient",
  kind: "request-only",
  create: (provider: AmazonConnectProvider) =>
    new MessageTemplateClient({ provider }) as unknown as Record<
      string,
      unknown
    >,
  events: [],
  requests: [
    { name: "isEnabled", args: [] },
    {
      name: "searchMessageTemplates",
      args: [{ k: "request", type: "json", required: true }],
    },
    // getContent(messageTemplateId, contactId) — two positional strings, not one wrapped object.
    {
      name: "getContent",
      args: [
        { k: "messageTemplateId", type: "string", required: true },
        { k: "contactId", type: "contactId", required: true },
      ],
    },
  ],
};
